import { useEffect, useState } from "react";
import { Gift } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage, fmtChips } from "../../lib/api";
import { Card, fmtNum, fmtWhen, inputCls } from "./ui";

// The sign-up promo: bonus chips on top of the starting stack for everyone who joins before the end date.
export const PromoPanel = () => {
  const [st, setSt] = useState(null);
  const [chips, setChips] = useState("");
  const [days, setDays] = useState("");
  const load = () => api.get("/api/admin/promo").then((r) => {
    setSt(r.data);
    setChips((c) => (c === "" ? String(r.data.chips || 10000) : c));
  }).catch((e) => toast.error(errorMessage(e)));
  useEffect(() => { load(); }, []);
  if (!st) return null;
  const patch = (body, msg) => api.patch("/api/admin/promo", body).then(() => { toast.success(msg); setDays(""); load(); })
    .catch((e) => toast.error(errorMessage(e)));
  const left = st.running ? Math.max(1, Math.ceil((new Date(st.ends_at) - Date.now()) / 86400000)) : 0;
  return (
    <Card title="Sign-up promo" testId="promo-panel">
      <div className="flex items-center gap-3 flex-wrap mb-3">
        <Gift className={`w-4 h-4 ${st.running ? "text-amber-300" : "text-slate-500"}`} />
        <span className="text-sm text-amber-50" data-testid="promo-status">
          {st.running ? `Running · ${fmtChips(st.chips)} bonus chips · ${left} day(s) left (ends ${fmtWhen(st.ends_at)})` : "Not running"}
        </span>
        <span className="text-xs text-slate-500" data-testid="promo-granted">{fmtNum(st.granted || 0)} player(s) paid so far</span>
      </div>
      <div className="flex items-end gap-2 flex-wrap">
        <label className="flex flex-col gap-1 text-[11px] text-slate-400">Bonus chips
          <input data-testid="promo-chips" type="number" min="0" step="1000" value={chips} onChange={(e) => setChips(e.target.value)} className={`${inputCls} w-32`} />
        </label>
        <label className="flex flex-col gap-1 text-[11px] text-slate-400">Run for (days)
          <input data-testid="promo-days" type="number" min="1" max="365" placeholder="14" value={days} onChange={(e) => setDays(e.target.value)} className={`${inputCls} w-28`} />
        </label>
        <button data-testid="promo-start" onClick={() => patch({ active: true, chips: Number(chips), days: Number(days || 14) }, "Promo started")}
          className="btn-gold rounded-full px-4 py-2 text-xs font-display tracking-wider">{st.running ? "Save / restart clock" : "Start promo"}</button>
        {st.running && (
          <button data-testid="promo-stop" onClick={() => patch({ active: false }, "Promo stopped")}
            className="rounded-full px-4 py-2 text-xs font-display tracking-wider border border-white/15 text-slate-300 hover:border-white/40">Stop now</button>
        )}
      </div>
      <p className="text-[11px] text-slate-500 mt-3">
        New players see the bonus on the sign-up form and again in a welcome window the first time they reach the lobby.
        Stopping it never takes chips off anyone already paid. Every grant is a PROMO_BONUS line in the ledger.
      </p>
    </Card>
  );
};
